import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ReadmeService } from '@services/readme/readme.service';
import { Models } from '@ibexfusion/models';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormComponent } from '../../../components/default-form/form.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MarkdownService } from 'ngx-markdown';
import { EditorOption } from 'angular-markdown-editor';
import { AssetSelectorComponent } from '../../../components/asset-selector/asset-selector.component';
import { OpenReadmeService } from '@services/readme/open-readme.service';
import { EnvironmentService } from '@services/environment/environment.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-readmes-edit',
    templateUrl: './readmes-edit.component.html',
    styleUrls: ['./readmes-edit.component.scss'],
    providers: [ReadmeService],
    standalone: false
})
export class ReadmesEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  isLoading = true;
  pageActions: PageAction[];

  id: string = null;
  readme: Models.Readme;
  translations = [];
  selectedTabIndex = 0;

  editorOptions: EditorOption;
  public imageAssetPath: any;
  public fileAssetPath: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private readmeService: ReadmeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    private markdownService: MarkdownService,
    private dialog: MatDialog,
    private openReadMeService: OpenReadmeService,
    private environmentService: EnvironmentService,
    private el: ElementRef
  ) {
    this.imageAssetPath = this.environmentService.getImageAssetPath();
    this.fileAssetPath = this.environmentService.getFileAssetPath();
  }

  ngOnInit() {
    this.isLoading = true;
    this.id = this.activatedRoute.snapshot.params['id'];
    if (this.id) {
      this.fetch();
    } else {
      this.create();
    }
    this.editorOptions = {
      iconlibrary: 'fa',
      parser: (val) => this.parse(val)
    };
    this.replaceAwesomeIcons();

  }

  replaceAwesomeIcons() {
    // @hack:  this is used because angular-markdown-editor is not compatible with font-awesome 5
    // todo check if it is possible to update this plugin (last check: January 2020, latest: v2.0.2)
    setTimeout(() => {
      const faPicture = this.el.nativeElement.querySelector('.fa-picture-o');
      const faHeader = this.el.nativeElement.querySelector('.fa-header');
      if (faPicture) {
        faPicture.className = ('fa fa-image');
      }
      if (faHeader) {
        faHeader.className = ('fa fa-heading');
      }
    }, 500);
  }

  fetch() {
    this.readmeService.get(this.id).then(readme => {
      this.readme = readme;
      this.loadForm(this.readme);
      this.isLoading = false;
    });
  }

  create() {
    this.readme = <Models.Readme>Models.ModelFactory.createModelInstanceByName('Readme');
    this.loadForm(this.readme);
    this.isLoading = false;
  }

  loadForm(model) {
    const formItem = DefaultFormComponent;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = model;
  }

  save() {
    this.isLoading = true;
    if (!this.id) {
      this.readmeService.create(this.readme).then(result => {
        this.router.navigate(['readmes', result._id]).then(() => {
          this.openReadMeService.reloadReadMes();
          this.snackbar.success('saved');
        });
      });
    } else {
      this.readmeService.update(this.id, this.readme).then(result => {
        this.openReadMeService.reloadReadMes();
        this.snackbar.success('saved');
      });
    }
  }

  parse(inputValue: string) {
    const markedOutput = this.markdownService.parse(_.trim(inputValue));
    setTimeout(() => {
      this.markdownService.highlight();
    });
    return markedOutput;
  }

  public chooseFromImageAssets(): void {
    let dialogRef: MatDialogRef<AssetSelectorComponent>;

    dialogRef = this.dialog.open(AssetSelectorComponent, {
      width: '448px',
      height: '550px',
      data: { type: 'image', disableCheckSize: true }
    });
    dialogRef.afterClosed().toPromise().then((asset: Models.ImageAsset) => {
      if (!asset) {
        return;
      }
      this.copyToClipboard(this.imageAssetPath + asset.path + '/freeForm');
    });
  }

  public chooseFromFileAssets(): void {
    let dialogRef: MatDialogRef<AssetSelectorComponent>;

    dialogRef = this.dialog.open(AssetSelectorComponent, {
      width: '448px',
      height: '550px',
      data: { type: 'file' }
    });
    dialogRef.afterClosed().toPromise().then((asset: Models.FileAsset) => {
      if (!asset) {
        return;
      }
      this.copyToClipboard(this.fileAssetPath + asset.path);
    });
  }

  copyToClipboard(path) {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = path;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    this.snackbar.open('copied path to clipbaord');
  }

  public addTranslation() {
    const translation = new Models.ReadmeTranslation();
    if (!this.readme.translations) {
      this.readme.translations = [];
    }
    this.readme.translations.push(translation);
  }

  public removeTranslation(index) {
    this.readme.translations.splice(index, 1);
  }

  public tabChange(event) {
    this.selectedTabIndex = event.index;
    this.replaceAwesomeIcons();
  }
}
